module.exports = __webpack_public_path__ + "img/area3_211021.60cd9737.jpg";